import { useCallback, useState } from 'react';
import { retrieveManually } from 'src/pages/admin/services/whitelistService';
import { WhitelistEntry } from './List';

const useManually = () => {
  const [records, setRecords] = useState<WhitelistEntry[]>([]);
  const [total, setTotal] = useState<number>(0);

  const retrieve = useCallback(async (page: number, pageSize: number) => {
    try {
      const response = await retrieveManually(page, pageSize);
      console.log('response: ', response);
      setRecords(response.data.items);
      setTotal(response.data.total);
    } catch (error) {
      console.log('error: ', error);
    }
  }, []);

  return {
    retrieve,
    records,
    total,
  };
};

export default useManually;
